export default class AdditionalOptions {
    constructor(selector, onOptionChangeCallback) {
        this.selector = selector;
        this.onOptionChangeCallback = onOptionChangeCallback;
        this.init();
    }

    // Hide all additional storage options
    hideAdditionalOptions() {
        $(this.selector).removeClass('active');
    }

    // Show additional storage options based on the country code
    showAdditionalOptions(countryCode) {
        this.hideAdditionalOptions();
        $(`${this.selector}[data-country="${countryCode}"]`).addClass('active');
    }

    // Initialize event listeners
    init() {
        $(`${this.selector} input`).on('change', () => {
            if (typeof this.onOptionChangeCallback === 'function') {
                this.onOptionChangeCallback();
            }
        });
    }
}